import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { Container } from "@material-ui/core";

import { checkSignedIn } from "./services/auth.service";

import Layout from "./pages/desktop/layout/Layout.component";
import MobileLoading from "./components/MobileLoading";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const MobileAuthenticatedRoute = props => {
    const { component: Component, ...rest } = props;

    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuthentication = async () => {
            setIsAuthenticated(await checkSignedIn());
            setLoading(false);
        };

        checkAuthentication();
    });

    if (loading) return <MobileLoading />;
    if (!isAuthenticated) return <Redirect to="/app/signin" />
    return (
        <Route {...rest} render={props => (
            <Container maxWidth="md" disableGutters={true} style={{ minHeight: window.innerHeight}}>
                <Component {...props} />
            </Container>
        )} />
    )
};

export const MobileRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={routeProps => (
                <Container maxWidth="md" disableGutters={true} style={{ minHeight: window.innerHeight }}>
                    <Component {...routeProps} />
                </Container>
            )}
        />
    );
};

export const MobileMultifactorRoute = ({ component: Component, ...rest }) => {
    let email = localStorage.getItem('email');
    if (!email) return <Redirect to="/app/signin" />
    if (rest.path.includes('otpverification')) {
        if (localStorage.getItem('is2FAEnabled') === 'false') {
            return <Redirect to="/app/authentication" />
        }
    }
    if (rest.path.includes('authentication')) {
        if (localStorage.getItem('is2FAEnabled') === 'true') {
            return <Redirect to="/app/otpverification" />
        }
    }
    return (
        <Route {...rest} render={props => (
            <Container maxWidth="md" disableGutters={true} style={{ minHeight: window.innerHeight }}>
                <Component {...props} />
            </Container>
        )} />
    )
}

export const DesktopRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={routeProps => (
                <Container maxWidth="xl" disableGutters={true} style={{ minHeight: window.innerHeight}}>
                    <Layout>
                        <Component {...routeProps} />
                    </Layout>
                </Container>
            )}
        />
    );
};

export const DesktopAuthenticatedRoute = props => {
    const { component: Component, ...rest } = props;

    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [hasRole, setHasRole] = useState(false);

    useEffect(() => {
        const checkAuthentication = async () => {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNEDUSER}`, {
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });
            if (response) {
                let json = await response.json();
                if (json.roles) {
                    setHasRole(json.roles.includes('provider') || json.roles.includes('administrator'));
                }
                else {
                    setHasRole(false);
                }

            }
            setIsAuthenticated(response.ok);
            setLoading(false);
        };
        checkAuthentication();
    });

    if (loading) return <MobileLoading />
    if (!hasRole) return <Redirect to="/provider/login" />
    if (!isAuthenticated) return <Redirect to="/provider/login" />
    return (
        <Route {...rest} render={routeProps => (
            <Container maxWidth="xl" disableGutters={true} style={{ minHeight: window.innerHeight }}>
                <Layout>
                    <Component {...routeProps} />
                </Layout>
            </Container>
        )} />
    )
};

export const DesktopAdminRoute = props => {
    const { component: Component, ...rest } = props;

    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNEDUSER}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (response) {
                    let json = await response.json();
                    setIsAdmin(json.roles.includes('administrator'));
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        checkAuthentication();
    });

    if (loading) return <MobileLoading />;
    if (!isAdmin) return <Redirect to="/provider/login" />
    return (
        <Route {...rest} render={routeProps => (
            <Container maxWidth="xl" disableGutters={true} style={{ minHeight: window.innerHeight}}>
                <Layout>
                    <Component {...routeProps} />
                </Layout>
            </Container>
        )} />
    )
};

export const DesktopRoleRoute = props => {
    const { component: Component, ...rest } = props;

    const [loading, setLoading] = useState(true);
    const [hasRole, setHasRole] = useState(false);

    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNEDUSER}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (response) {
                    let json = await response.json();
                    setHasRole(json.roles.includes(props.role));
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        checkAuthentication();
    });

    if (loading) return <MobileLoading />
    if (!hasRole) return <Redirect to="/provider/login" />
    return (
        <Route {...rest} render={routeProps => (
            <Container maxWidth="xl" disableGutters={true} style={{ minHeight: window.innerHeight }}>
                <Layout>
                    <Component {...routeProps} />
                </Layout>
            </Container>
        )} />
    )
};